// Contact Center pages, in sidebar order, with the names people see.
// The keys are backend/src/services/ccAccess.js CC_VIEWS.
export const CC_VIEW_LABELS = {
  live_ops:         'Live Ops',
  agents:           'Agents',
  team_performance: 'Team Performance',
  director: 'Director',
  manager: 'Manager',
  supervisor: 'Supervisor',
  staffing:         'Staffing',
  repeat_callers:   'Repeat Callers',
  email:            'Email',
  city:             'City',
  leadership:       'Leadership',
  exec:             'Executive Overview',
  vp:               'VP Dashboard',
  outbound:         'Outbound',
};

// Which pages a role opens in each chosen department: the role must allow the
// page AND the department must carry it. The server decides access with the
// same rule (ccAccess.decideCcAccess); this only previews it, so an
// administrator sees what a grant does before saving it.
export function previewCcPages(role, departments) {
  if (!role) return [];
  return departments
    .map((d) => ({
      id: d.id,
      label: d.label,
      views: Object.keys(CC_VIEW_LABELS).filter((v) => role.allowed_views.includes(v) && d.view_keys.includes(v)),
    }));
}

// Whether the signed-in person may open `view` for department `dept`, from the
// server's own summary (/auth/me user.contactCenter.departments). Pages built
// for one department ask this rather than the flat `views` list: an OBC
// supervisor holds "agents" too, but Support's Agents page would refuse them.
export function ccCanOpen(user, view, dept) {
  return !!user?.contactCenter?.departments?.some((d) => d.id === dept && d.views.includes(view));
}

// Live Ops, Agents and Team Performance answer for whichever department is
// asked for (the page carries a switcher), so their links are drawn when the
// person can open them in ANY department they hold — an OBC supervisor gets
// Agents, and sees OBC's agents on it. The rest of the section is Support's:
// Repeat callers, City, Email and Leadership were Support's pages in the old
// app and have no department form yet.
export function ccCanOpenAnywhere(user, view) {
  return !!user?.contactCenter?.departments?.some((d) => d.views.includes(view));
}
